import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar.js'
import { TopBar } from './TopBar.js'
import { GuidedTour } from '../../HelpTour/GuidedTour.js'
import { ConnectivityBanner, Footer } from '../../Component/index.js'
import { GlobalModalHost } from '../../Modal/GlobalModalHost.js'
import { PageLoadHooks } from './PageLoadHooks.js'

export const LayoutShell = (props: { useFullWidth?: boolean; appMode?: boolean }) => {
  // appMode: viewport-height shell for pages that manage their own scrolling (e.g. chat)
  const { appMode } = props
  return (
    <>
      <GlobalModalHost />
      <PageLoadHooks />
      <GuidedTour />
      {/* Above the TopBar so it is visible on every route, home included */}
      <ConnectivityBanner />
      {/* TopBar always spans full width */}
      <TopBar drawerName={'sidebar-drawer'} />

      {/* Sidebar + Content inside drawer */}
      <div className="drawer lg:drawer-open min-h-[calc(100vh-4rem)]">
        {/* Adjust for topbar height if needed */}
        <input id="sidebar-drawer" type="checkbox" className="drawer-toggle" />
        <div
          className={`drawer-content flex flex-col bg-body-default ${
            appMode ? 'h-[calc(100vh-4rem)] overflow-hidden' : 'justify-between h-fit min-h-[calc(100vh-4rem)]'
          }`}
        >
          <main className={`w-full p-4 ${appMode ? 'min-h-0 flex-1' : 'h-fit'}`}>
            <div className={props.useFullWidth ? (appMode ? 'h-full' : '') : 'max-w-[110rem] mx-auto'}>
              <Outlet />
            </div>
          </main>
          {!appMode && <Footer />}
        </div>
        {!props.useFullWidth && <Sidebar />}
      </div>
    </>
  )
}
